(function () {

    'use strict';

    angular.module('FotocApp')

        .component('tools', {

            templateUrl: (USE_TEMPLATE_CACHE ? '' : window.BASE_PATH + '../../src/') + 'editor/tools.component.html',
            bindings: {},
            controller: ['$scope', '$editorService', '$canvasService', '$document', function ($scope, $editorService, $canvasService, $document) {

                var self = this;
                this.$editorService = $editorService;

                this.$onInit = function () {

                    jqA(document).on('click', '.uploadcare--page', function ($e) {
                        $e.stopPropagation();
                    });

                    if ($editorService.ui.showTools) {
                        jqA(document).on('click', function ($e) {
                            if ($editorService.ui.toolOpen === 'layouts' || $editorService.ui.toolOpen === 'favs') {
                                $editorService.ui.toolOpen = 'transform';
                            } else if ($editorService.ui.toolOpen !== 'transform' && $editorService.ui.toolOpen !== 'images' && $editorService.ui.toolOpen !== 'filters' && $editorService.ui.toolOpen !== 'frames') {
                                $editorService.ui.toolOpen = false;
                            }
                            $scope.$apply();
                        });
                    }

                    $scope.$watch('$ctrl.$editorService.data.layout_size', function (a, b) {
                        if (a) {
                            $editorService.setLayout($editorService.data.layout_id, a);
                        }
                    });
                }

                this.stopPropagation = function ($event) {
                    $event.stopPropagation();
                };

                this.close = function () {
                    $editorService.ui.toolOpen = false;
                }

                function inViewport(el) {
                    var r, html;
                    if (!el || 1 !== el.nodeType) {
                        return false;
                    }
                    html = document.documentElement;
                    r = el.getBoundingClientRect();

                    return (!!r
                        && r.bottom >= 0
                        && r.right >= 0
                        && r.top <= html.clientHeight
                        && r.left <= html.clientWidth
                    );
                }

                this.open = function ($key_tool) {
                    if (!inViewport(document.getElementById('canvas-editor'))) document.getElementById('canvas-editor').scrollIntoView({
                        behavior: 'smooth',
                        block: 'center'
                    })

                    $editorService.ui.view = {type: 'edit'}
                    if ($editorService.ui.toolOpen === $key_tool) {
                        $editorService.ui.toolOpen = false;
                    } else {

                        $editorService.ui.toolOpen = $key_tool;
                    }
                }
            }]
        })
})();